export default __webpack_public_path__ + "static/media/i.1320d8eb.png";